namespace SP {

    export function getHashData() {
        var hash = window.location.hash.substr(1);
        var data: { [name: string]: string } = {};
        var groups = hash.split('&');
        for (var i = 0; i < groups.length; i++) {
            var item = groups[i].split("=");
            if (item[0])
                data[item[0]] = window.decodeURIComponent(item[1]);
        }
        return data;
    }


    export function getHash(name: string) {
        var value = getHashData()[name];
        //console.log("getHash", name, value);
        return value;
    }

    export function setHash(name: string, value: string) {
        var data = getHashData();
        if (dataEquals(data[name], value)) return;

        if (!value) delete data[name];
        else data[name] = value;

        var arr = [];
        for (var name in data) {
            arr.push(name + "=" + data[name]);
        }

        window.location.hash = "#" + arr.join("&");
    }

    export function setManyHash(params: { [name: string]: string }) {
        var data = getHashData();

        for (let name in params) {
            let value = params[name];
            if (dataEquals(data[name], value)) continue;

            if (!value) delete data[name];
            else data[name] = value;
        }

        var arr = [];
        for (var name in data) {
            arr.push(name + "=" + data[name]);
        }

        window.location.hash = "#" + arr.join("&");
    }

    export function setAllHash(params: { [name: string]: string }) {
        var current = getHashData();
        var data = params;

        if (dataEquals(current, data)) return;

        var arr = [];
        for (var name in data) {
            if (data[name] !== undefined) { 
                arr.push(name + "=" + data[name]);
            }
        }

        window.location.hash = "#" + arr.join("&");
    }
}